import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "itemsContainer",
    "itemRow",
    "itemTemplate",
    "itemTotalPrice",
    "itemVatAmount",
    "itemTotalWithVat",
    "totalAmountWithoutTax",
    "totalTax",
    "totalAmountWithTax",
    "template",
    "entries",
    "supplyItemTemplate",
    "supplyItemClassTemplate",
    "supplyItemClass",
  ];

  connect() {
    console.log("Expense controller called");
    if (this.element.isConnected) {
      console.log("Controller is mounted and connected to DOM");
      this.calculateAllTotals();
    }
  }

  addSupplyItem(event) {
    event.preventDefault();
    const content = this.supplyItemTemplateTarget.innerHTML.replace(
      /NEW_RECORD/g,
      new Date().getTime(),
    );
    console.log(content);
    this.entriesTarget.insertAdjacentHTML("beforeend", content);
  }

  removeSupplyItem(event) {
    event.preventDefault();
    // Find and remove the field when the remove button is clicked
    const wrapper = event.target.closest(".nested-fields");
    wrapper.remove();
  }

  addSupplyItemClass(event) {
    event.preventDefault();
    const content = this.supplyItemClassTemplateTarget.innerHTML.replace(
      /NEW_RECORD/g,
      new Date().getTime(),
    );
    console.log(content);
    this.supplyItemClassTarget.insertAdjacentHTML("beforeend", content);
  }

  removeSupplyItemClass(event) {
    event.preventDefault();
    const wrapper = event.target.closest(".nested-fields");
    wrapper.remove();
  }

  calculateItemTotals(event) {
    const row = event.target.closest("[data-expense-target='itemRow']");
    const quantity =
      parseFloat(row.querySelector("[name*='[item_quantity]']").value) || 0;
    const unitPrice =
      parseFloat(row.querySelector("[name*='[item_unit_price]']").value) || 0;
    const vatRate =
      parseFloat(row.querySelector("[name*='[item_vat_rate]']").value) || 0;

    // The server's rule (Expenses::ItemAmounts): francs CFA have no cents,
    // the price excluding tax and the VAT of a line are each rounded, the
    // half franc going up. The preview said 83662.50 where the recap and
    // the expense say 83 663 (QA EXP4-09).
    const totalPrice = Math.round(quantity * unitPrice);
    const vatAmount = Math.round((totalPrice * Math.round(vatRate * 100)) / 10000);
    const totalWithVat = totalPrice + vatAmount;

    // Update the row's calculated fields
    row.querySelector("[data-expense-target='itemTotalPrice']").value =
      totalPrice;
    row.querySelector("[data-expense-target='itemVatAmount']").value =
      vatAmount;
    row.querySelector("[data-expense-target='itemTotalWithVat']").value =
      totalWithVat;

    // Recalculate all totals
    this.calculateAllTotals();
  }

  calculateAllTotals() {
    let totalWithoutTax = 0;
    let totalTax = 0;
    let totalWithTax = 0;

    this.itemRowTargets.forEach((row) => {
      totalWithoutTax +=
        parseFloat(
          row.querySelector("[data-expense-target='itemTotalPrice']").value,
        ) || 0;
      totalTax +=
        parseFloat(
          row.querySelector("[data-expense-target='itemVatAmount']").value,
        ) || 0;
      totalWithTax +=
        parseFloat(
          row.querySelector("[data-expense-target='itemTotalWithVat']").value,
        ) || 0;
    });

    // Update the total fields
    this.totalAmountWithoutTaxTarget.value = Math.round(totalWithoutTax);
    this.totalTaxTarget.value = Math.round(totalTax);
    this.totalAmountWithTaxTarget.value = Math.round(totalWithTax);
  }

  // A new line is a copy of the form's own line, rendered by the server in
  // a <template>: the same fields, labels and layout as the first (QA R2-10).
  addItem(event) {
    event.preventDefault();
    if (!this.hasItemTemplateTarget) return;

    this.itemsContainerTarget.appendChild(
      this.itemTemplateTarget.content.cloneNode(true)
    );
  }

  removeItem(event) {
    event.preventDefault();
    const row = event.target.closest("[data-expense-target='itemRow']");
    row.remove();
    this.calculateAllTotals();
  }
}
